import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=57c92f1a"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c92f1a')) {
      api.createRecord('57c92f1a', component.options)
    } else {
      api.reload('57c92f1a', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=57c92f1a", function () {
      api.rerender('57c92f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/RMC/Protein/rmcFeedPlantList/detail.vue"
export default component.exports